import React, { FC } from 'react';
import { StyledPrivate } from './styled';

const Label: FC<{
  title: string;
  isDark: boolean;
}> = ({ title, isDark }) => <StyledPrivate isDark={isDark}>{title}</StyledPrivate>;

export default Label;
